/* eslint-disable no-useless-catch */
import * as fetchService from '../../../sharedmodules/services/fetch';
import { handleError } from '../../../sharedmodules/services/error-handlers';

const basePath = '/api';

const headerOptions = (accessToken) => ({
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
});

export async function getDuplicatePinPlate(getAccessToken, duplicatePinPlatePaylod) {

    const endPoint = `${basePath}/admin/products/pin/plate/collection`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
        },
        body: JSON.stringify(duplicatePinPlatePaylod),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function putDuplicatePinPlate(getAccessToken, duplicatePinPlate) {

    const endPoint = `${basePath}/products/pin/plate/`;
    const accessToken = await getAccessToken();

    const body = {
        ...duplicatePinPlate,
    };

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
        },
        body: JSON.stringify(body),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}
